import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withRights } from '../../../../../providers/RightsConsumer';
import { Grid, FormControlLabel, Switch } from '@mui/material';
import { TextField, Card, Typography, Autocomplete } from '@totalsoft/rocket-ui';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import DeleteIcon from '@mui/icons-material/Delete';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { GridfilledItemWrapper, DeleteIconButtonRoot } from '../ChecklistStyles';

const CheckListRowComponent = ({
  item,
  idx,
  onPropertyChange,
  toggleItemDeletion,
  documentChecklistWrite,
  readOnlyFull,
  checklists,
  validationInfo,
  t
}) => {
  const isItemSelectedForDeletion = Boolean(item?.selectedForDeletion);

  return (
    <>
      <Card
        title={
          !item.fulfilled ? (
            <Typography>
              {t('Document.CheckList.AddedOn') +
                t('DATE_FORMAT', { date: { value: item.addedOn, format: 'DD/MMM/YY HH:mm:ss' } }) +
                t('Document.CheckList.By', { data: { name: item.userName } })}
            </Typography>
          ) : (
            <Typography>
              {t('Document.CheckList.FulfilledOn') +
                t('DATE_FORMAT', { date: { value: item.fulfilledOn, format: 'DD/MMM/YY HH:mm:ss' } }) +
                t('Document.CheckList.By', { data: { name: item.fulfillerName ?? item.userName } })}
            </Typography>
          )
        }
        icon={AssignmentIcon}
      >
        <Grid container spacing={1}>
          <GridfilledItemWrapper item xs={2} lg={1}>
            <FormControlLabel
              control={
                <Switch
                  id={'checkList_' + idx + '_fulfilled1'}
                  checked={item.fulfilled || false}
                  onChange={onCheckBoxChange(onPropertyChange('fulfilled'))}
                  color='primary'
                  name='fulfilled'
                  disabled={!documentChecklistWrite || readOnlyFull}
                />
              }
              label={t('Document.CheckList.Fulfilled')}
            />
          </GridfilledItemWrapper>
          <Grid item xs={7} md={3} mt={-1}>
            <Autocomplete
              id={'checkList_' + idx + '_conditionType'}
              fullWidth
              name='contitionType'
              value={item.checklistId}
              valueKey='id'
              labelKey='name'
              label={t('Document.CheckList.ConditionType')}
              simpleValue
              options={checklists}
              onChange={onPropertyChange('checklistId')}
              disabled={!documentChecklistWrite || readOnlyFull}
              isClearable
              error={Boolean(validationInfo && validationInfo.checklistId)}
              helperText={validationInfo && validationInfo.checklistId}
              sx={theme => ({ marginLeft: theme.spacing(3) })}
            />
          </Grid>
          <Grid item xs={3} md={7} lg={8} sx={{ textAlign: 'end' }} mt={-1}>
            <DeleteIconButtonRoot
              id={'checkList_' + idx + '_deleteBtn'}
              component='span'
              onClick={toggleItemDeletion}
              tooltip={
                isItemSelectedForDeletion ? t('Document.CheckList.DeselectItemFromDeletion') : t('Document.CheckList.SelectItemForDeletion')
              }
              deletionStatus={isItemSelectedForDeletion}
              color={'transparent'}
            >
              <DeleteIcon />
            </DeleteIconButtonRoot>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id={'checkList_' + idx + '_condition'}
              label={t('Document.CheckList.Condition')}
              multiline
              fullWidth
              value={item.condition || ''}
              onChange={onPropertyChange('condition')}
            />
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

CheckListRowComponent.propTypes = {
  onPropertyChange: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  idx: PropTypes.number,
  toggleItemDeletion: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  documentChecklistWrite: PropTypes.bool,
  readOnlyFull: PropTypes.bool,
  checklists: PropTypes.array.isRequired,
  validationInfo: PropTypes.object.isRequired
};

export default withTranslation()(withRights(CheckListRowComponent));
